import { category as categoryIcon } from "assets/icons";
import styled from "@emotion/styled";
import {  Col, Form, Select, Spin } from "antd";
import { FC, useEffect, useState } from "react";
import {  GetMasterRetailType, MasterRetailTypeData } from "services/interface";
import { useGetRetailType } from "hooks/useMasterData";

const { Option } = Select;

interface Option {
  value: string | number;
  label: string | number;
}

interface ProductRetailTypeCardProps {
  is_active?: boolean;
}

const ProductRetailTypeCard: FC<ProductRetailTypeCardProps> = ({ is_active }) => {
   const [reatilType, setRetailType] = useState<MasterRetailTypeData[]>([]);

   // const { data, isLoading } = useGetCategory();
  const { data, isLoading } = useGetRetailType();

  useEffect(() => {
    if (data) {
      setRetailType(data.data);
    }
   //console.log("data", data);
  }, [data]);

 // console.log("category", category);

  const children: React.ReactNode[] = [];

  reatilType.forEach((item) => {
    children.push(<Option key={item.id} id={item.id} >{item.description}</Option>);
  });


  return (
    <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 12 }} >
      <WrapperAll>
        <SpanIcon>{categoryIcon}</SpanIcon>
        <FormWrapper>
          <Form.Item
            label="ประเภทสินค้า"
            name="retail_type"
            rules={[{ required: true, message: "กรุณาเลือกประเภทสินค้า" }]}
          >
            <Select
             mode="multiple"
              showSearch
              placeholder="ประเภทสินค้า"
              optionFilterProp="children"
              notFoundContent={isLoading ? <Spin size="small" /> : null}
              loading={isLoading}
              onChange={(value) => console.log(value)}
            >
              {children}
            </Select>
            {/* <Cascader
              placeholder="กรุณาเลือกหมวดหมู่สินค้า"
              loading={isLoading}
              options={options}
              onChange={(value) => console.log(value)}
            /> */}
          </Form.Item>
        </FormWrapper>
      </WrapperAll>
    </Col>
  );
};

export default ProductRetailTypeCard;

const FormWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  padding: 20px 20px 0px 20px;
  border-radius: 8px;
`;

const SpanIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 76px;
`;

const WrapperAll = styled.div`
  display: flex;
  flex-direction: row;
  align-items: start;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 8px;
`;
